module.exports = __webpack_public_path__ + "static/media/location-white.afb9383e.svg";